<div class="row align-items-center">
  <div class="col-12 mb-3">
    <nb-button-group (valueChange)="updateRangeChange($event)">
      <button *ngIf="!required" [pressed]="selectedDateRange === 'All'" (click)="setDateRange('All')" value="All"
              nbButtonToggle>از ابتدا
      </button>
      <button *ngIf="type === 'rangeDateTime'" nbButtonToggle value="1h" [pressed]="selectedDateRange === '1h'"
              (click)="setDateRange('1h')">یک ساعت پیش
      </button>
      <button *ngIf="type === 'rangeDateTime'" nbButtonToggle value="3h" [pressed]="selectedDateRange === '3h'"
              (click)="setDateRange('3h')">سه ساعت پیش
      </button>
      <button nbButtonToggle value="Today" [pressed]="selectedDateRange === 'Today'" (click)="setDateRange('Today')">
        امروز
      </button>
      <button nbButtonToggle value="Yesterday" [pressed]="selectedDateRange === 'Yesterday'"
              (click)="setDateRange('Yesterday')">دیروز
      </button>
      <button nbButtonToggle value="ThreeDaysAgo" [pressed]="selectedDateRange === 'ThreeDaysAgo'"
              (click)="setDateRange('ThreeDaysAgo')">سه روز گذشته
      </button>
      <button nbButtonToggle value="AWeekAgo" [pressed]="selectedDateRange === 'AWeekAgo'"
              (click)="setDateRange('AWeekAgo')">یک هفته گذشته
      </button>
      <button nbButtonToggle value="ThisMonth" [pressed]="selectedDateRange === 'ThisMonth'"
              (click)="setDateRange('ThisMonth')">{{ currentMonthName }}
      </button>
      <button nbButtonToggle value="LastMonth" [pressed]="selectedDateRange === 'LastMonth'"
              (click)="setDateRange('LastMonth')">{{ previousMonthName }}
      </button>
    </nb-button-group>
  </div>
  <div class="row align-items-center" [class.d-none]="selectedDateRange === 'All'">
    <div class="col-auto">
      <span>از تاریخ</span>
    </div>
    <div class="col-5">
      <app-date-timepicker [disableTime]="type === 'rangeDate'" (selectDateTime)="getDate($event,'from')"
                           #FromDateTime></app-date-timepicker>
    </div>
    <div class="col-auto">
      <span>تا تاریخ</span>
    </div>
    <div class="col-5">
      <app-date-timepicker [disableTime]="type === 'rangeDate'" (selectDateTime)="getDate($event,'to')"
                           #ToDateTime></app-date-timepicker>
    </div>
  </div>
</div>
